// extracted by mini-css-extract-plugin
module.exports = {"floatingButton":"styles_floatingButton__r2lP6","contentEditorPopover":"styles_contentEditorPopover__6uhdV","contentFlexContainer":"styles_contentFlexContainer__Io6OC"};